import React, { useState } from 'react';

import './styles.css';

import paymentServices from '../../../../../services/academy/paymentServices';

import { Dots } from "react-activity";

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input';
import { FaFileSignature, FaDollarSign } from 'react-icons/fa';

function PopupRenewEnrollment(props) {
    const dateNow = new Date();
    const [date, setDate] = useState(`${dateNow.getFullYear()}-${String(dateNow.getMonth() + 1).padStart(2, '0')}-${String(dateNow.getDate()).padStart(2, '0')}`);
    const [scholarship, setScholarship] = useState("Não");
    const [type, setType] = useState("Mensal");
    const [duration, setDuration] = useState(0);
    const [payment, setPayment] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploading, setUploading] = useState(false);

    function convertEnrollmentTime(op) {
        switch (op) {
            case '3 meses':
                return 3;
            case '6 meses':
                return 6;
            default:
                return 12;
        }
    }

    async function createEnrollment() {
        if (date && (type && paymentServices.tipos_periodo.find(item => item[1] === type)) && duration && scholarship && (scholarship === "Sim" || (scholarship === "Não" && Number(payment)))) {
            console.log(
                props.studentId,
                date,
                paymentServices.tipos_periodo.find(item => item[1] === type)[0],
                duration,
                selectedFile,
                `Contrato ${date.split('-').slice(0, 2).reverse().join('/')}${scholarship === "Sim" ? " [BOLSA]" : ""}`,
                Number(payment),
                Number(discount),
                scholarship === "Sim" ? true : false
            );
            setUploading(true);
            const response = await paymentServices.postEnrollment(
                props.studentId,
                date,
                paymentServices.tipos_periodo.find(item => item[1] === type)[0],
                duration,
                selectedFile,
                `Contrato ${date.split('-').reverse().join('/')}${scholarship === "Sim" ? " [BOLSA]" : ""}`,
                Number(payment),
                Number(discount),
                scholarship === "Sim" ? true : false
            );
            setUploading(false);
            if (response.status === 201) {
                props.onCreate();
                setDate(`${dateNow.getFullYear()}-${String(dateNow.getMonth() + 1).padStart(2, '0')}-${String(dateNow.getDate()).padStart(2, '0')}`);
                setDuration('');
                setScholarship("Não");
                setPayment(0);
                setDiscount(0);
                setSelectedFile(null);
                props.setVisibility(false);
            } else
                alert("Erro ao registrar matrícula, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios*");
    };

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaDollarSign />}
            tittle='Registro de matrícula'
        >
            <form action="" className='student-renew-enrollment-form'>
                <div className='line'>
                    <Input
                        label='Início do contrato*'
                        type='date'
                        id='student-renew-enrollment-date'
                        onChange={(event) => setDate(event.target.value)}
                        value={date}
                    />

                    <Input
                        label='Bolsista*'
                        type='select'
                        options={["Não", "Sim"]}
                        noFilterOptions
                        id='student-renew-enrollment-scholarship'
                        onChange={(event) => setScholarship(event.target.value)}
                        value={scholarship}
                    />
                </div>

                <div className='line'>
                    <Input
                        label='Tipo de parcela*'
                        type='select'
                        options={paymentServices.tipos_periodo.map(item => item[1])}
                        noFilterOptions
                        id='student-renew-enrollment-type'
                        onChange={(event) => setType(event.target.value)}
                        value={type}
                    />

                    <Input
                        label='Parcelas*'
                        type='number'
                        min={1}
                        id='student-renew-enrollment-duration'
                        onChange={(event) => setDuration(event.target.value)}
                        value={duration}
                    />
                </div>

                {
                    scholarship !== "Sim" ?
                        <div className='line'>
                            <Input
                                label='Valor*'
                                placeholder='Ex.: R$ 100.00'
                                type='currency'
                                id='student-renew-enrollment-payment'
                                onChange={(event) => setPayment(event.target.value)}
                                value={payment}
                            />
                            <Input
                                label='Desconto'
                                placeholder='Ex.: R$ 20.00'
                                type='currency'
                                max={Number(payment)}
                                id='student-renew-enrollment-discount'
                                onChange={(event) => setDiscount(event.target.value)}
                                value={discount}
                            />
                        </div>
                        : []
                }

                <Input
                    label={selectedFile ? selectedFile.name : "Anexar contrato"}
                    type='file'
                    accept='application/pdf'
                    className='student-renew-enrollment-file-input'
                    id='student-renew-enrollment-file'
                    icon={<FaFileSignature />}
                    onChange={(event) => setSelectedFile(event.target.files[0])}
                />

                <button
                    type='button'
                    className='green'
                    onClick={() => uploading ? alert("Um envio já está em andamento.") : createEnrollment()}
                >
                    {
                        uploading ?
                            <Dots />
                            : "Registrar"
                    }
                </button>
            </form>
        </Popup>
    )
}

export default PopupRenewEnrollment;